import React from "react";

export const IconLine = ({ handleClick = false, color }) => (
  <svg
    width="16"
    height="2"
    viewBox="0 0 16 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <rect y="0.5" width="16" height="1" fill={color} />
  </svg>
);

export default IconLine;
